export const isProduction = (environment: string) => environment === 'production' || environment === 'productionna';
